// Laravel used to put authentication and route-dispatch metadata in every
// request body.  Flask derives both from the bearer token and the URL, so
// those fields must never cross the client/API boundary.
export const withoutLegacyAuthority = (values = {}) => {
  const payload = { ...(values || {}) };
  delete payload.auth_key;
  delete payload.action;
  return payload;
};

// Multipart endpoints still use FormData for files or nested provider
// payloads, but authentication and route dispatch come from the bearer header
// and URL. Keep the same authority boundary as JSON requests.
export const appendFormValues = (formData, values = {}) => {
  Object.entries(values || {}).forEach(([key, value]) => {
    if (key === "auth_key" || key === "action") return;
    formData.append(key, value);
  });
  return formData;
};
